<div class="network-page row m-0 h100">
    <div class="flex nowrap flex-1 flex-column items-stretch lost-connection-screen">
        <app-connection-settings automation="staticIpComponent"></app-connection-settings>
    </div>
</div>
